import { useState, useEffect } from "react";

/**
 * Custom hook that tracks whether this is the initial app load.
 * Shows loading animation only on the first page load (when browser tab opens),
 * not on subsequent navigation within the app.
 *
 * Uses sessionStorage to persist the "already loaded" flag for the browser session.
 *
 * @param {number} duration - How long to show the loader in ms (default: 2000)
 * @returns {boolean} - Whether to show the preloader
 */
const useInitialLoad = () => {
  // No artificial delay - return false immediately
  // Preloader should only be shown during actual data loading operations
  return false;
};

export default useInitialLoad;
